<div class="{{ cssClass(data) }}">
  <div
    fxLayout="row"
    [@fadeAnimation]="{
      value: animationState,
      params: {
        fadeIn: getToastConfigFadeIn(),
        fadeOut: getToastConfigFadeOut()
      }
    }"
    (@fadeAnimation.done)="onFadeFinished($event)">
    <div class="toast-header-container ie-flex-auto" *ngIf="data.title" fxFlex>
      <div fxLayoutAlign="start center">
        <mat-icon aria-hidden="false">{{ getIcon(data) }}</mat-icon>
      </div>
      <div class="header-title ie-flex-auto" fxLayoutAlign="center center" fxFlex>
        {{ data.title }}
      </div>
      <div fxLayoutAlign="end center">
        <mat-icon class="icon-close" (click)="close()" matTooltip="fechar">close</mat-icon>
      </div>
    </div>
  </div>
  <div fxLayout="row">
    <div fxLayoutAlign="center center" fxFlex [innerHTML]="data.text"></div>
    <div *ngIf="!data.title" fxLayoutAlign="end center">
      <mat-icon class="icon-close" (click)="close()" matTooltip="fechar">close</mat-icon>
    </div>
  </div>
</div>
